import { call, put, spawn, takeLatest } from 'redux-saga/effects'
import { GlobalDataService } from '../../../services/globalData.service'
import { GlobalDataConstants } from '../../globalData/store/globalData.constants'
import { setAppSettingsEntries } from '../store/configurations.actions'
import { IAppSettingsEntry } from '../store/configurations.types'
import { drainOverdueAndPending } from '../../pcrBackup/saga/drainOverdueAndPending.saga'
import Logger from '../../../services/logger.service'

function* loadAppSettings() {
  try {
    const globalDataService = new GlobalDataService()
    const doc: { entity?: IAppSettingsEntry[] } | undefined | null = yield call(
      [globalDataService, globalDataService.getDocument],
      'app_settings'
    )
    const entries = doc?.entity ?? []
    Logger.info(
      `setAppSettingsSaga: Loaded app_settings (${entries.length} entries)\n${entries
        .map((e) => `  ${e.key} = ${e.value}`)
        .join('\n')}`
    )
    yield put(setAppSettingsEntries(entries))
  } catch (e) {
    Logger.errorObj('setAppSettingsSaga: Failed to load app_settings — using defaults', e)
    yield put(setAppSettingsEntries([]))
  }
  yield spawn(drainOverdueAndPending)
}

export function* setAppSettingsSaga() {
  yield takeLatest([GlobalDataConstants.ON_GLOBAL_DATA_IMPORT_SUCCESS], loadAppSettings)
}
